import { IRouteNode } from './route-node';

export interface PortalToken {
  expiration: string;
  token: string;
  refreshToken: string;
  refreshTokenExpires: string;
  msClient: string;
  location: string;
  tenantId: string;
  pSeq: number;
  firstName: string;
  lastName: string;
  email: string;
  bookingPolicyAccepted: boolean;
  useBookingPolicy: boolean;
  bookingPolicyText: string;
  maxBookingHours: number;
  cancellationPolicyAccepted: boolean;
  useCancellationFee: boolean;
  cancellationPolicyText: string;
}